<template>
  <div class="payment-detail-page">
    <PageHeader icon="fas fa-file-invoice-dollar">
      <template #title>Detail Invoice #{{ data.id || "-" }}</template>
      <template #subtitle>
        Pratinjau invoice A5 dan struk thermal, histori angsuran, serta sisa
        pembayaran
      </template>
      <template #actions>
        <b-button
          class="payment-detail-back"
          @click="$router.push('/payment/list')"
        >
          <i class="fas fa-arrow-left"></i><span>Kembali ke Daftar</span>
        </b-button>
      </template>
    </PageHeader>

    <div class="row payment-detail-layout">
      <div class="col-lg-9 col-12">
        <div class="row payment-detail-previews">
          <div class="col-lg-8 col-12 payment-detail-preview-column">
            <div class="payment-detail-preview-label">
              <span><i class="far fa-file-alt"></i> Invoice A5</span>
              <small>Setengah kertas A4 · printer dokumen umum</small>
            </div>
            <div class="payment-detail-preview payment-detail-preview--a4">
              <Print
                :data="data"
                height="210mm"
                width="148mm"
                :setting="setting"
                :showSummary="true"
                :items="items"
                :renderNotes="renderNotes"
              />
            </div>
          </div>

          <div class="col-lg-4 col-12 payment-detail-preview-column">
            <div class="payment-detail-preview-label">
              <span><i class="fas fa-receipt"></i> Struk Thermal</span>
              <small>Printer kasir 80 mm</small>
            </div>
            <div class="payment-detail-preview payment-detail-preview--thermal">
              <PrintThermal
                :data="data"
                width="80mm"
                :isPrint="true"
                :setting="setting"
                :showSummary="true"
                :items="items"
                :renderNotes="renderNotes"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="d-none">
        <!-- <Print
        :data="data"
        height="297mm"
        width="58mm"
        :isPrint="true"
        :setting="setting"
        :showSummary="true"
        :items="items"
        :renderNotes="renderNotes"
        :notes="data.notes"
      /> -->
        <!-- <Print
        :data="data"
        height="297mm"
        width="58mm"
        :isPrint="true"
        :setting="setting"
        :showSummary="true"
        :items="items"
        :renderNotes="renderNotes"
        :notes="data.notes"
      /> -->
        <!-- <div
        v-if="items.length > 10"
        id="print"
      >
        <Print
          v-for="(n, index) in new Array(papers).fill(null)"
          :data="data"
          height="170mm"
          :isPrint="true"
          :key="index"
          :setting="setting"
          :showSummary="(index + 1) == itemsMultiPapers.length"
          :items="itemsMultiPapers[index]"
          :renderNotes="renderNotes"
          :notes="data.notes"
        />
    </div> -->
      </div>

      <!-- PDF -->
      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        :filename="'struk-transaksi-' + data.patient_name"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a5"
        pdf-orientation="portrait"
        @progress="onProgress($event)"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf"
      >
        <section slot="pdf-content">
          <Print
            :data="data"
            height="210mm"
            width="148mm"
            :isPrint="true"
            :setting="setting"
            :showSummary="true"
            :items="items"
            :renderNotes="renderNotes"
            :notes="data.notes"
          />
          <!-- <template v-if="items.length > 10">
        <Print
          v-for="(n, index) in new Array(papers).fill(null)"
          :data="data"
          height="143.8mm"
          :isPrint="true"
          :key="index"
          :setting="setting"
          :showSummary="(index + 1) == itemsMultiPapers.length"
          :items="itemsMultiPapers[index]"
          :renderNotes="renderNotes"
          :notes="data.notes"
        />
      </template> -->
        </section>
      </vue-html2pdf>

      <div class="col-lg-3 col-12 payment-detail-sidebar">
        <section class="payment-detail-panel payment-detail-actions">
          <div class="payment-detail-panel__heading">
            <div>
              <small>AKSI INVOICE</small>
              <h3>Cetak & pembayaran</h3>
            </div>
          </div>
          <div class="payment-detail-action-grid">
            <b-button
              class="payment-detail-action payment-detail-action--primary"
              @click="btnPrintOnClick"
            >
              <i class="fas fa-print"></i><span>Cetak A5</span>
            </b-button>
            <b-button
              class="payment-detail-action payment-detail-action--thermal"
              :disabled="!canPrintReceipt"
              :title="
                canPrintReceipt
                  ? 'Cetak bukti pembayaran'
                  : 'Struk tersedia setelah ada pembayaran'
              "
              @click="btnPrintThermalOnClick"
            >
              <i class="fas fa-receipt"></i><span>Cetak Struk</span>
            </b-button>
            <b-button
              class="payment-detail-action payment-detail-action--download"
              @click="btnDownloadOnClick"
            >
              <i class="fas fa-file-pdf"></i><span>Unduh</span>
            </b-button>
            <!-- <b-button
        v-if="data.payment_status_id != 3 && data.payment_status_id != 4"
        squared
        :class="'d-block mt-2'"
        size="sm"
        variant="success"
        @click="$router.push('/payment/edit/' + data.id)"
      >Edit Pembayaran</b-button> -->
            <b-button
              v-if="data.payment_status_id != 3 && data.payment_status_id != 4"
              class="payment-detail-action payment-detail-action--payment"
              @click="$router.push('/payment/edit/' + data.id)"
            >
              <i class="fas fa-plus-circle"></i><span>Angsuran</span>
            </b-button>
            <b-button
              class="payment-detail-action payment-detail-action--billing"
              @click="$router.push('/payment/billing/' + data.id)"
            >
              <i class="fas fa-cash-register"></i><span>Billing Control</span>
            </b-button>
          </div>
        </section>

        <section v-if="payment_slips.length != 0" class="payment-detail-panel">
          <div class="payment-detail-panel__heading">
            <div>
              <small>RIWAYAT</small>
              <h3>Pembayaran</h3>
            </div>
            <span class="payment-detail-count">{{ payment_slips.length }}</span>
          </div>
          <div
            class="payment-detail-payment"
            v-for="(item, index) in payment_slips"
            :key="item.id"
            @click="
              $router.push(
                `/payment/slip-detail/${item.payment_id}/${item.id}?terms=${
                  index + 1
                }`
              )
            "
          >
            <div>
              <div class="d-flex align-items-center justify-content-between">
                <strong>Pembayaran #{{ index + 1 }}</strong>
                <strong class="payment-detail-payment__amount"
                  >Rp {{ paymentAmount(item).toLocaleString("id-ID") }}</strong
                >
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <small
                  >{{
                    new Date(item.date)
                      .toLocaleString("id-ID", {
                        day: "numeric",
                        month: "2-digit",
                        year: "numeric",
                      })
                      .replaceAll("/", "-")
                  }}
                  -
                  <span class="font-weight-bold">{{
                    item.payment_method_name
                  }}</span></small
                >
                <i class="fas fa-chevron-right"></i>
              </div>
            </div>
          </div>
        </section>

        <section class="payment-detail-panel payment-detail-balance">
          <div class="payment-detail-panel__heading">
            <div>
              <small>RINGKASAN TAGIHAN</small>
              <h3>Sisa pembayaran</h3>
            </div>
          </div>
          <strong
            >Rp
            {{
              numberValue(data.unpaid_amount).toLocaleString("id-ID")
            }}</strong
          >
          <span>{{
            numberValue(data.unpaid_amount) > 0 ? "Belum lunas" : "Lunas"
          }}</span>
        </section>
      </div>
      <PrintThermalReal
        class="d-none"
        :data="data"
        :isPrint="true"
        :setting="setting"
        :showSummary="true"
        :items="items"
        :renderNotes="renderNotes"
        :notes="data.notes"
      />
    </div>
  </div>
</template>

<script>
// components
import Print from "@/component/payments/Print.vue";
import PrintThermal from "@/component/payments/PrintThermal.vue";
import PrintThermalReal from "@/component/payments/PrintThermalReal.vue";

import VueHtml2pdf from "vue-html2pdf";
import module from "@/core/modules/CrudModule.js";
import ApiService from "@/core/services/api.service";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  components: {
    Print,
    PrintThermal,
    PrintThermalReal,
    VueHtml2pdf,
  },

  data() {
    return {
      // Data
      data: {},
      payment_slips: [],
      items: [],
      itemsMultiPapers: [],
      papers: 1,
      // access management
      manipulateBtn: false,
      // setting
      setting: {},
      // other
      renderNotes: true,
    };
  },

  computed: {
    canPrintReceipt() {
      return (
        this.numberValue(this.data.paid_amount) -
          this.numberValue(this.data.refunded_amount) >
        0
      );
    },
  },

  methods: {
    numberValue(value) {
      if (typeof value === "number") return Number.isFinite(value) ? value : 0;
      const normalized = String(value == null ? "" : value).replace(
        /[^0-9-]/g,
        ""
      );
      return normalized ? parseInt(normalized, 10) || 0 : 0;
    },

    paymentAmount(item) {
      const tendered = this.numberValue(item && item.payment_amount);
      const change = Math.max(this.numberValue(item && item.change_amount), 0);
      return Math.max(
        Math.min(tendered - change, this.numberValue(this.data.final_amount)),
        0
      );
    },

    async getSetting() {
      this.setting = await module.get(`settings/${1}`);
    },

    async getPayment() {
      this.data = await module.get(`payments/${this.$route.params.id}`);
      this.payment_slips = await module.get(
        `payment-slips/get-by-payment/${this.$route.params.id}`
      );
      // If Data Not found
      if (this.data == null) {
        // Redirect To List
        this.$router.push("/payment/list");
      }
    },

    async getPaymentDetail() {
      this.items = await module.list(
        `payment-details/${this.$route.params.id}`
      );
      this.papers = Math.ceil(this.items.length / 10);
      let start = 0;
      for (let j = 0; j < this.papers; j++) {
        this.itemsMultiPapers.push(this.items.slice(start, start + 10));
        start += 10;
      }
    },

    async registerPrint(format) {
      await ApiService.post(`billing/payments/${this.data.id}/print`, {
        format,
      });
      await this.getPayment();
      await this.$nextTick();
    },

    async btnPrintOnClick() {
      await this.registerPrint("a5");
      this.renderNotes = false;
      this.$htmlToPaper("print");
      this.renderNotes = true;
    },
    async btnPrintThermalOnClick() {
      if (!this.canPrintReceipt) {
        this.$bvToast.toast(
          "Struk hanya dapat dicetak setelah ada pembayaran.",
          { title: "Belum ada pembayaran", variant: "warning", solid: true }
        );
        return;
      }
      await this.registerPrint("thermal");
      this.renderNotes = false;
      this.$htmlToPaper("print-thermal");
      this.renderNotes = true;
    },

    async btnDownloadOnClick() {
      await this.registerPrint("pdf");
      this.renderNotes = false;
      await this.$refs.html2Pdf.generatePdf();
      this.renderNotes = true;
    },

    onProgress($event) {
      console.log("onProgress", $event);
    },

    hasStartedGeneration() {
      console.log("hasStartedGeneration");
    },

    hasGenerated($event) {
      console.log("hasGenerated", $event);
    },

    // access management
    async setActiveMenu() {
      let access_right_user = window.localStorage.getItem(
        "access_right_display"
      );
      let access_right = JSON.parse(access_right_user);
      for (let a = 0; a < access_right.length; a++) {
        if (access_right[a] == "6002") {
          this.manipulateBtn = true;
        }
      }
    },
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Keuangan" },
      { title: "Pembayaran", route: "/payment/list" },
      { title: "Detail" },
    ]);
    // Get Data
    this.getPayment();
    this.getSetting();
    this.getPaymentDetail();
    this.setActiveMenu();
  },
};
</script>

<style lang="scss" scoped>
.payment-detail-page {
  padding-bottom: 28px;
}
.payment-detail-layout,
.payment-detail-previews {
  margin-right: -8px;
  margin-left: -8px;
}
.payment-detail-layout > [class*="col-"],
.payment-detail-previews > [class*="col-"] {
  padding-right: 8px;
  padding-left: 8px;
}
.payment-detail-preview-column {
  min-width: 0;
  margin-bottom: 16px;
}
.payment-detail-preview-label {
  min-height: 46px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 4px 9px;
  color: #1f3047;
}
.payment-detail-preview-label span {
  font-size: 13px;
  font-weight: 750;
}
.payment-detail-preview-label i {
  width: 24px;
  color: #1e958f !important;
}
.payment-detail-preview-label small {
  color: #71859b;
  font-size: 10.5px;
  text-align: right;
}
.payment-detail-preview {
  overflow: auto;
  padding: 8px;
  border: 1px solid #dce6ef;
  border-radius: 16px;
  background: #edf3f7;
  box-shadow: 0 12px 30px rgba(20, 50, 99, 0.07);
}
.payment-detail-preview ::v-deep > .card {
  margin: 0 auto !important;
  border-radius: 4px !important;
  box-shadow: 0 7px 22px rgba(31, 48, 71, 0.12) !important;
}
.payment-detail-preview--a4 ::v-deep > .card {
  width: 100%;
  max-width: 148mm;
  min-height: 210mm;
}
.payment-detail-preview--a4 ::v-deep > .card > .card-body {
  padding: 14px !important;
}
.payment-detail-preview--a4 ::v-deep table {
  font-size: 11px;
}
.payment-detail-preview--thermal {
  display: flex;
  justify-content: center;
  padding: 8px 6px;
}
.payment-detail-preview--thermal ::v-deep > .card {
  width: 80mm !important;
  max-width: 100%;
}
.payment-detail-preview--thermal ::v-deep > .card > .card-body {
  width: 80mm !important;
  max-width: 100%;
  height: auto !important;
  min-height: 210mm;
  padding: 11px 10px !important;
  overflow: hidden;
}
.payment-detail-sidebar {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.payment-detail-panel {
  padding: 16px;
  border: 1px solid #e0e8f0;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 9px 24px rgba(20, 50, 99, 0.055);
}
.payment-detail-panel__heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 13px;
}
.payment-detail-panel__heading small {
  display: block;
  margin-bottom: 2px;
  color: #1e958f;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.12em;
}
.payment-detail-panel__heading h3 {
  margin: 0;
  color: #1f3047;
  font-size: 15px;
  font-weight: 750;
}
.payment-detail-action-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
.payment-detail-action {
  min-height: 42px;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 9px 10px !important;
  border: 0 !important;
  border-radius: 10px !important;
  color: #fff !important;
  font-size: 11px !important;
  font-weight: 750 !important;
  box-shadow: none !important;
}
.payment-detail-action i,
.payment-detail-action span {
  color: #fff !important;
}
.payment-detail-action--primary {
  background: #155487 !important;
}
.payment-detail-action--thermal {
  background: #187f82 !important;
}
.payment-detail-action--thermal,
.payment-detail-action--thermal span {
  white-space: nowrap !important;
}
.payment-detail-action--download {
  background: #586b82 !important;
}
.payment-detail-action--payment {
  background: #16945c !important;
}
.payment-detail-action--billing {
  background: #7248a8 !important;
}
.payment-detail-back {
  min-height: 40px;
  padding: 9px 14px !important;
  border: 1px solid #d5e1eb !important;
  border-radius: 10px !important;
  color: #155487 !important;
  background: #fff !important;
  font-size: 11px !important;
  font-weight: 700 !important;
}
.payment-detail-back i {
  margin-right: 7px;
  color: #155487 !important;
}
.payment-detail-count {
  min-width: 28px;
  height: 28px;
  display: inline-grid;
  place-items: center;
  border-radius: 50%;
  color: #176f72;
  background: #e5f4f1;
  font-size: 11px;
  font-weight: 800;
}
.payment-detail-payment {
  margin-top: 8px;
  padding: 11px;
  border: 1px solid #e4ebf2;
  border-radius: 11px;
  background: #f8fafc;
  cursor: pointer;
  transition: border-color 0.18s ease, transform 0.18s ease;
}
.payment-detail-payment:hover {
  border-color: #8ccbc6;
  transform: translateY(-1px);
}
.payment-detail-payment strong {
  color: #31465f;
  font-size: 11.5px;
}
.payment-detail-payment small {
  color: #71859b;
  font-size: 10px;
}
.payment-detail-payment__amount {
  color: #155487 !important;
}
.payment-detail-payment i {
  color: #1e958f !important;
  font-size: 9px;
}
.payment-detail-balance > strong {
  display: block;
  color: #e14444;
  font-size: 21px;
  font-weight: 800;
}
.payment-detail-balance > span {
  display: inline-flex;
  margin-top: 5px;
  padding: 4px 8px;
  border-radius: 999px;
  color: #b83838;
  background: #fff0f0;
  font-size: 10px;
  font-weight: 750;
}
@media (min-width: 992px) {
  .payment-detail-sidebar {
    position: sticky;
    top: 92px;
    align-self: flex-start;
  }
}
@media (max-width: 991.98px) {
  .payment-detail-sidebar {
    margin-top: 4px;
  }
  .payment-detail-action-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
@media (max-width: 767.98px) {
  .payment-detail-action-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 575.98px) {
  .payment-detail-action-grid {
    grid-template-columns: 1fr;
  }
  .payment-detail-preview {
    padding: 10px;
    border-radius: 12px;
  }
  .payment-detail-preview-label {
    align-items: flex-start;
    flex-direction: column;
    gap: 2px;
  }
  .payment-detail-preview-label small {
    text-align: left;
  }
}
</style>
